import script from "./userlogin.vue?vue&type=script&setup=true&lang=js"
export * from "./userlogin.vue?vue&type=script&setup=true&lang=js"

import "./userlogin.vue?vue&type=style&index=0&id=4d2d451e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2d451e"]])

export default __exports__